import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RolesStorageService {
  private roleKey = 'userRoles';
  private permissionKey = 'userPermissions';

  setRoles(roles: string[]): void {
    localStorage.setItem(this.roleKey, JSON.stringify(roles));
  }

  getRoles(): string[] {
    const roles = localStorage.getItem(this.roleKey);
    return roles ? JSON.parse(roles) : [];
  }

  setPermissions(permissions: string[]): void {
    localStorage.setItem(this.permissionKey, JSON.stringify(permissions));
  }

  hasPermission(permission: string): boolean {
    const stored = localStorage.getItem(this.permissionKey);
    const permissions: string[] = stored ? JSON.parse(stored) : [];
    return permissions.includes(permission);
  }

  clear(): void {
    localStorage.removeItem(this.roleKey);
    localStorage.removeItem(this.permissionKey);
  }
}
